import { CircleHelp, ClipboardCheck, FileText, ListChecks, Trophy, type LucideIcon } from "lucide-react";
import type { ManualBodyStep } from "@arc/contracts";

/** The icon of a step type, the same in the outline and on the step card. */
export const STEP_TYPE_ICON: Record<ManualBodyStep["type"], LucideIcon> = {
  regular: FileText,
  question: CircleHelp,
  checklist: ListChecks,
  question_with_score: ClipboardCheck,
  show_score: Trophy,
};
